
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"90","height":"80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M89.049 37.024l-16.576-14.12c0-.069.068-.205.068-.342V4.076c0-1.092-.887-1.978-1.978-2.047h-9.21c-1.091 0-1.978.955-1.978 2.047v7.64L46.141.46c-.682-.613-1.773-.613-2.524 0L.71 37.024c-.819.682-.955 1.91-.273 2.729.682.818 1.91.955 2.728.273l.069-.069 41.68-35.472 14.939 12.688 8.936 7.572L86.66 39.957c.819.682 2.047.614 2.73-.204.613-.819.477-2.047-.342-2.729zM68.721 19.63l-5.39-4.57V5.918h5.39v13.711z","fill":"#9A9B9C"}}),_c('path',{attrs:{"d":"M80.522 40.913l-5.457-4.64L46.14 11.58c-.682-.614-1.773-.614-2.524 0L14.694 36.274l-5.457 4.639c-.819.682-.887 1.91-.205 2.728.682.819 1.91.887 2.66.205l2.388-2.115v36.291A1.98 1.98 0 0016.058 80h57.506a1.98 1.98 0 001.978-1.978V41.799l2.388 2.115c.341.273.75.478 1.228.478.546 0 1.091-.273 1.5-.683.82-.886.683-2.114-.136-2.796zm-27.9 35.267H37.137V55.238h15.485V76.18zm3.888 0V53.396c0-1.091-.818-1.978-1.842-1.978h-19.51c-1.09 0-1.841.955-1.841 1.978V76.18h-15.28V38.457l26.877-22.92 26.876 22.92v37.655H56.51v.068z","fill":"#9A9B9C"}})])
          )
        }
      }
    